import { combineReducers } from "redux";
// import { applyMiddleware, combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
// import thunk from "redux-thunk";
import authReducer from "./reducers/auth-reducer";
import createDispatchStep from "./reducers/create-dispatch-step";
import addCardStep from "./reducers/add-card-step";
// import appReducer from './reducers';

const rootReducer = combineReducers({
  auth: authReducer,
  createDispatchStep,
  addCardStep,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
// export default configureStore(appReducer, applyMiddleware(thunk));
